var script = {
  name: 'PendoCollapseTransition',
  functional: true,
  props: {
    appear: {
      type: Boolean,
      default: false
    }
  },
  render(h, _ref) {
    let {
      props,
      children
    } = _ref;
    const data = {
      props: {
        name: 'pendo-transition-collapse',
        appear: props.appear
      },
      on: {
        enter(element) {
          const {
            width
          } = getComputedStyle(element);
          element.style.width = width;
          element.style.position = 'absolute';
          element.style.visibility = 'hidden';
          element.style.height = 'auto';
          const {
            height
          } = getComputedStyle(element);
          element.style.width = null;
          element.style.position = null;
          element.style.visibility = null;
          element.style.height = 0;
          getComputedStyle(element).height;
          requestAnimationFrame(() => {
            element.style.height = height;
          });
        },
        afterEnter(element) {
          element.style.height = 'auto';
        },
        leave(element) {
          const {
            height
          } = getComputedStyle(element);
          element.style.height = height;
          getComputedStyle(element).height;
          requestAnimationFrame(() => {
            element.style.height = 0;
          });
        }
      }
    };
    return h('transition', data, children);
  }
};

export { script as default };
//# sourceMappingURL=pendo-collapse-transition.vue2.js.map
